import React, { useEffect } from 'react';
// import { proveedores } from '../../json/proveedores';
import { bases } from '../../json/revisionbases';
import './revisionbases.css';
import { Link } from 'react-router-dom';

const Proveedores = () => {  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container transparencia-container container-mh'>
        <div className='row'>
          <div className='col-12'>
            <h1 className='title'>Revisión de Bases</h1>
            <hr className='hr-gob'/>
          </div>
          {
                 bases.map((item, index)=>(
                  
                  
                  <Link key={ index }  target="_blank" to={ item.url ? item.url : "" + item.nombre } className='col-md-4 col-sm-6 col-12 transparencia_item'>
                   

                   <div >
                      <a class="text-decoration-none"  >
                        <button class="css-02a1-0 btn btn-outline-primary" tabindex="0" type="button">
                            <div class="css-02b">
                            <i class="fa-solid fa-solid fa-file-word" aria-hidden="true"></i>
                           
                           
                            </div><p class="css-02text text-wrap text-bk">{ item.nombre }</p>
                        </button>
                      </a>
                  </div>


                    {/* <div className='ligas_container'>
                      
                      <h3>{ item.nombre }</h3>
                    </div> */}
                  </Link>
                ))
            }
            {/* <Link className='rubros_historicos' to="RubrosHistoricos">Información Ejercicios Anteriores Art. 69 (48 Fracciones)</Link> */}
        </div>
        
    



    </div>
  )
}

export default Proveedores